// extracted by mini-css-extract-plugin
module.exports = {"title":"data-push-setting_title__2ZSLP","apply":"data-push-setting_apply__OzW1_","formTitle":"data-push-setting_formTitle__2kkeS","location":"data-push-setting_location__25-EB"};